import { match } from "#/utils/match";

export const SLIPPAGE_CONFIG = {
  options: {
    highDelta: {
      conservativeThreshold: 0.69,
      thresholdForValidation: 0.7, // to match BE
      values: [5, 6, 7.5],
      max: 10, // BE limit 10%,
      maxSlippageFactor: 0.1, // max % / 100
    },
    midDelta: {
      conservativeThreshold: 0.29,
      thresholdForValidation: 0.3, // to match BE
      values: [15, 18, 20],
      max: 25, // BE limit 25%,
      maxSlippageFactor: 0.25, // max % / 100
    },
    lowDelta: {
      conservativeThreshold: 0,
      thresholdForValidation: 0, // to match BE
      values: [20, 30, 40],
      max: 50, // BE limit 50%,
      maxSlippageFactor: 0.5, // max % / 100
    },
  },
  perps: {
    values: [0.25, 0.5, 0.75],
    max: 1.5, // BE limit 1.5%,
    maxSlippageFactor: 0.015, // max % / 100
  },
};

export const getMaxSlippageFactor = (isOption: boolean, delta = 0) => {
  if (!isOption) return SLIPPAGE_CONFIG.perps.maxSlippageFactor;

  const { highDelta, midDelta, lowDelta } = SLIPPAGE_CONFIG.options;

  return (
    match([
      [highDelta.maxSlippageFactor, delta >= highDelta.thresholdForValidation],
      [midDelta.maxSlippageFactor, delta >= midDelta.thresholdForValidation],
    ]) ?? lowDelta.maxSlippageFactor
  );
};
